import { getBrowserApiBase } from '@data/api-base';
import { api } from '@data/store';
import { PhilBotApp, PhillConnections, UserEntity } from '@data/utils/types';

export const login = (token: string): Promise<UserEntity> =>
  api.post(`/auth/google`, { token }, { withCredentials: true });

export const loginWithPassword = (email: string, password: string): Promise<UserEntity> =>
  api.post(`/auth/login`, { email, password }, { withCredentials: true });

// Succeeds whether or not the address has an account, so the response says nothing about who is a
// user here. The confirmation screen is shown either way.
export const forgotPassword = (email: string): Promise<void> => api.post(`/auth/forgot-password`, { email });

export const resetPassword = (token: string, password: string): Promise<void> =>
  api.post(`/auth/reset-password`, { token, password });

export const changePassword = (currentPassword: string, newPassword: string): Promise<UserEntity> =>
  api.post(`/auth/change-password`, { currentPassword, newPassword }, { withCredentials: true });

// No current password, because the caller has none yet. `withCredentials` for the same reason the
// change does: the API hands back a fresh cookie along with the headers.
export const setPassword = (password: string): Promise<UserEntity> =>
  api.post(`/auth/set-password`, { password }, { withCredentials: true });

export const refresh = (token: string): Promise<void> =>
  api.post(`/auth/refresh`, { token }, { withCredentials: true });

// Each source authorises and withdraws on its own route, because each is its own consent — see the
// API's auth controller. Keyed by the same names the settings rows use.
const SOURCE_PATHS: Record<PhilBotApp, string> = {
  github: '/auth/github',
  googleCalendar: '/auth/google-calendar',
  slack: '/auth/slack-user',
};

export const fetchConnections = (): Promise<PhillConnections> => api.get(`/auth/connections`);

export const disconnectSource = (source: PhilBotApp): Promise<void> => api.delete(SOURCE_PATHS[source]);

// A full page navigation, not a fetch: the far end is the provider's consent screen, and it has to be
// the browser that goes there. `clientRedirect` is where the API sends it back to afterwards.
export const connectSourceUrl = (source: PhilBotApp, clientRedirect: string): string =>
  `${getBrowserApiBase()}${SOURCE_PATHS[source]}/authorize?clientRedirect=${encodeURIComponent(clientRedirect)}`;
